module.exports = __webpack_public_path__ + "static/langwarn-97ff1be6117fb41e3590706b241c8fee.png";